import React, { useState, useEffect, useCallback } from "react";
import Modal from '../components/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeUp, faPause } from "@fortawesome/free-solid-svg-icons";
import "../assets/templates/ChooseCorrectAnswer.css";
import { getMetrics, createMetrics, updateMetrics } from "../service/service";
import LessonInstruction from "../containers/instruction/LessonInstruction";
import { useAppGlobalConfig } from "../providers/AppGlobalConfigContext";
import useAudioPlayback from "../hooks/useAudioPlayback";

const ChooseCorrectAnswer = (props) => {
  const { bookName, totalIndexes, lessonId, blockData, contentIndex, step, blockIndex, audioUrl } = props;
  const [data, setData] = useState([]);
  const [songPlaying, setSongPlaying] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [totalAttempts, setTotalAttempts] = useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [btnModalText, setBtnModalText] = useState("Tentar novamente");
  const [modalErrorMsg, setModalErrorMsg] = useState("Erro ao registrar seu progresso. Clique no botão abaixo para tentar novamente");
  const [initTime, setInitTime] = useState(Date.now());
  const [metrics, setMetrics] = useState(null);

  const { state, togglePlayback } = useAudioPlayback(audioUrl, 'choose_correct_answer');

  const { isEmbedMode } = useAppGlobalConfig();
  let tenant = isEmbedMode ? 'cupheadless' : 'cupfranchise'
  const userInfo = JSON.parse(localStorage.getItem("user-info"));



  useEffect(() => {
    getWords();
    setIsChecked(false);
    setIsCorrect(false);
    setIsSelected(false);
    getMetricsData();
  }, [blockIndex]);

  const getMetricsData = useCallback(async () => {
    try {
      const resp = await getMetrics(userInfo.id, blockData.block_id, tenant)
      if (resp.data) {
        setMetrics(resp.data)
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setMetrics(null)
      } else {
        console.error("Erro ao buscar métricas:", error);
      }
    }
  }, [blockIndex]);

  const closeModal = () => {
    setModalOpen(false);
    step('forward', true);
  };

  const buttonModalAction = async () => {
    setIsLoading(true);
    setBtnModalText('Enviando...');
    try {
      await registerProgress()
    } catch (error) {
      setModalErrorMsg("O erro ainda continua.. Tente novamente ou clique no botão de fechar para avançar para a próxima lição")
    }
    setIsLoading(false);
    setBtnModalText('Tentar novamente');
  };

  const registerProgress = async () => {
    const params = {
      "userId": userInfo.id,
      "blockId": blockData.block_id,
      "template": "choose_correct_answer",
      "bookName": bookName,
      "lessonId": lessonId,
      "scores": [{
        "isRight": true,
        "accuracy": 100,
        "elapsedTime": Date.now() - initTime,
        "dateTime": new Date(initTime).toISOString(),
        "totalAttempts": totalAttempts
      }],
      "sectionId": blockData.sectionId,
      "section": blockData.section,
      "index": blockData.num,
      "totalIndexes": totalIndexes
    };

    if (metrics) {
      await updateMetrics(params, tenant);
    } else {
      await createMetrics(params, tenant);
    }
    step('forward', true);
  }

  const shuffle = (a) => {
    let j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  };

  const getWords = () => {
    let dataYes = blockData.complement.yes;
    let dataNo = blockData.complement.no;
    let arrYes = [
      {
        value: dataYes,
        clicked: false,
      },
    ];
    let arrNo = [];
    let concatObj = [];

    if (typeof dataNo === 'object') {
      arrNo = dataNo.map((value) => ({
        value: value,
        clicked: false,
      }));
    } else {
      arrNo.push({
        value: dataNo,
        clicked: false,
      });
    }
    concatObj = arrNo.concat(arrYes);
    setData(shuffle(concatObj));
  }

  const selectOption = (item) => {
    const newData = [...data];
    newData.forEach((value) => {
      if (item.value === value.value) {
        value.clicked = true;
        if (item.value === blockData.complement.yes) {
          setIsCorrect(true)
        }
      } else {
        value.clicked = false;
      }
    });

    setData(newData);
    setIsSelected(true);
  };

  const handlePlayPause = () => {
    togglePlayback();
  };

  const endSong = () => {
    setPlaying(false);
    setSongPlaying(null);
  }

  const actionBtnClick = async () => {
    if (isCorrect) {
      try {
        await registerProgress()
      } catch (error) {
        setModalOpen(true);
      }
    } else {
      setTotalAttempts(prev => prev + 1);
      setIsChecked(false);
      setIsCorrect(false);
      setIsSelected(false);
      getWords();
    }
  }

  const checkAnswer = () => {
    setIsChecked(true);
  }

  const btnClasses = (item) => {
    const answer = blockData.complement.yes
    let classes = ["btn-option"];
    if (isChecked) {
      if (item.clicked) {
        if (item.value === answer) {
          classes.push("btn-option-correct")
        }
        else {
          classes.push("btn-option-incorrect")
        }
      } else {
        classes.push("btn-option-disabled")
      }
    } else {
      if (item.clicked) {
        classes.push("btn-option-clicked")
      }
    }
    return classes.join(' ')
  }

  return (
    <div className="default-card container new-bg-color">
      {blockData.content[contentIndex].type === "instruction" ? (
        <>
          <LessonInstruction
            instructionText={blockData.content[contentIndex].instruction}
            audioUrl={audioUrl}
          />
        </>
      ) : (
        <div style={{ width: "100%" }}>
          <Modal
            isOpen={isModalOpen}
            onClose={closeModal}
            isLoading={isLoading}
            onActionButtonClick={buttonModalAction}
            message={modalErrorMsg}
            actionButtonText={btnModalText} />
          <div
            className="song-container"
            onClick={handlePlayPause}>
            <div className="song-icon">
              {state === 'playing'
                ? <FontAwesomeIcon className="icon-step" icon={faPause} />
                : <FontAwesomeIcon className="icon-step" icon={faVolumeUp} />
              }
            </div>
          </div>

          <div className="options-container">
            <ul style={{ listStyle: "none", padding: 0 }}>
              {data.map((item, index) => (
                <li key={index} style={{ marginBottom: "10px" }}>
                  <button
                    disabled={isChecked}
                    onClick={() => {
                      selectOption(item);
                    }}
                    className={`${btnClasses(item)}`}
                  >
                    <div className={`option-index ${item.clicked ? "clicked" : ""}`}>
                      {index + 1}
                    </div>
                    {`${item.value}`}</button>
                </li>
              ))}
            </ul>
          </div>

          {
            isChecked &&
            <button className="btn-check" onClick={() => actionBtnClick()}>
              {isCorrect ? "Continue" : "Try Again"}
            </button>

          }

          {
            !isChecked &&
            <button disabled={!isSelected} className="btn-check" onClick={() => checkAnswer()}>
              Check Answer
            </button>
          }
        </div>
      )}
    </div>
  );

}

export default ChooseCorrectAnswer;
